import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchIsIncludedInProTheme } from './documentSpecificDataAccess';
import {
  getIsGlobalDocumentIncludedInProTheme,
  setIsGlobalDocumentIncludedInProTheme,
} from './documentSpecificState';

function* handleGetIsGlobalDocumentIncludedInProTheme(action) {
  const { href } = action.payload;
  try {
    const result = yield call(fetchIsIncludedInProTheme, href);
    yield put(setIsGlobalDocumentIncludedInProTheme(result));
  } catch (error) {
    console.error('Error fetching is included in pro theme', error);
  }
}

export function* watchDocumentSpecificSagas() {
  yield takeEvery(
    getIsGlobalDocumentIncludedInProTheme.type,
    handleGetIsGlobalDocumentIncludedInProTheme,
  );
}
